import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_ADMIN_USER, DUMMY_BASIC_USER, DUMMY_MANAGER_USER } from "Data/Dummy/User";
import { createAppSlice } from "Data/Redux/Store";
import type { UserManagmentState } from "Interfaces";

const initialState: UserManagmentState = {
	users: [ DUMMY_ADMIN_USER, DUMMY_MANAGER_USER, DUMMY_BASIC_USER ]
};

// #region Reducers

const setUserManagementReducer = (state: UserManagmentState, action: PayloadAction<UserManagmentState>) => {
	return action.payload;
};

// #endregion

// #region Selectors

export const getUserManagementSettings = (state: UserManagmentState) => {
	return state;
};

// #endregion

const managementSlice = createAppSlice({
	name: "management",
	initialState,
	reducers: {
		setUserManagementAction: setUserManagementReducer
	},
	selectors: {
		selectUserManagementSettings: getUserManagementSettings
	}
});

export default managementSlice;

export const { setUserManagementAction } = managementSlice.actions;
export const { selectUserManagementSettings } = managementSlice.selectors;
